import React from 'react'
import HTag from '@/lib/HTag'
import Richtext from '@/lib/rt/Richtext'
import CTA from '@/lib/CTA'
import Img from '@/lib/Img'
import clsx from 'clsx'

const BePartnerSection = ({ heading, _rawRichtext, cta, image, accent}) => {
	const style =
		accent === '#FFC28B' ? 'bg-orange-light' :
		accent === '#FFC42F' ? 'bg-sunshine' :
		accent === '#E4F9FA' ? 'bg-light-blue' :
		accent === '#F7E9D4' ? 'bg-tan text-orange' :
		accent === '#0F2938' ? 'bg-grounding-navy text-white' :
		accent === '#7FC7C5' ? 'bg-caribbean' :
		'bg-orange text-white'

	return (
		<section className={clsx(style, 'py-10 <md:py-6')}>
			<div className="max-w-screen-xl relative grid md:grid-cols-2 mx-auto px-5 py-10 <md:py-6 justify-center items-center gap-12 md:gap-20">
				<div className="md:partner-line" />
				<figure>
					<Img className="z-10" image={image} />
				</figure>
				<div className="richtext">
					<HTag className="h1" {...heading} />
					<Richtext className="leading-normal" raw={_rawRichtext} />
					<CTA {...cta} />
				</div>
			</div>
		</section>

	)
}

export default BePartnerSection
